// eslint-disable-next-line
export default {
  methods: {
    fillForm(form, data) {
      return Object.assign({}, form, data);
    },
  },
};
